import { useEffect, useMemo, useState } from 'react';
import {
  Box,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  InputAdornment,
  IconButton,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { debounce } from 'lodash';
import { Search, SearchIconWrapper, StyledInputBase } from '../SearchInput';

const SupplementaryOfferFilters = ({
  searches,
  filters,
  rowsPerPage,
  onSearchChange,
  onFilterChange,
  onRowsPerPageChange,
  onNewOffer,
}) => {
  const { esimFilter, dataSimFilter, asanImzaFilter } = filters;

  const [localSearches, setLocalSearches] = useState({
    offerIdSearch: searches.offerIdSearch,
    primaryOfferIdSearch: searches.primaryOfferIdSearch,
    titleSearch: searches.titleSearch,
  });

  const debouncedOnSearchChange = useMemo(
    () => debounce((field, value) => onSearchChange(field, value), 500),
    [onSearchChange]
  );

  useEffect(() => () => debouncedOnSearchChange.cancel(), [debouncedOnSearchChange]);

  const handleSearchChange = (field, value) => {
    setLocalSearches((prev) => ({ ...prev, [field]: value }));
    debouncedOnSearchChange(field, value);
  };

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
      <Stack direction="column" spacing={2} sx={{ my: 2 }}>
        <Search>
          <SearchIconWrapper>
            <SearchIcon />
          </SearchIconWrapper>
          <StyledInputBase
            onChange={(e) => handleSearchChange('offerIdSearch', e.target.value)}
            value={localSearches.offerIdSearch}
            placeholder="Search by OfferID…"
            inputProps={{ 'aria-label': 'search offer id' }}
            endAdornment={
              localSearches.offerIdSearch && (
                <InputAdornment position="end">
                  <IconButton
                    onMouseDown={(e) => e.preventDefault()}
                    size="small"
                    onClick={() => handleSearchChange('offerIdSearch', '')}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              )
            }
          />
        </Search>

        <Search>
          <SearchIconWrapper>
            <SearchIcon />
          </SearchIconWrapper>
          <StyledInputBase
            onChange={(e) => handleSearchChange('primaryOfferIdSearch', e.target.value)}
            value={localSearches.primaryOfferIdSearch}
            placeholder="Search by PrimaryOfferID…"
            inputProps={{ 'aria-label': 'search primary offer id' }}
            endAdornment={
              localSearches.primaryOfferIdSearch && (
                <InputAdornment position="end">
                  <IconButton
                    onMouseDown={(e) => e.preventDefault()}
                    size="small"
                    onClick={() => handleSearchChange('primaryOfferIdSearch', '')}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              )
            }
          />
        </Search>

        <Search>
          <SearchIconWrapper>
            <SearchIcon />
          </SearchIconWrapper>
          <StyledInputBase
            onChange={(e) => handleSearchChange('titleSearch', e.target.value)}
            value={localSearches.titleSearch}
            placeholder="Search by Title…"
            inputProps={{ 'aria-label': 'search title' }}
            endAdornment={
              localSearches.titleSearch && (
                <InputAdornment position="end">
                  <IconButton
                    onMouseDown={(e) => e.preventDefault()}
                    size="small"
                    onClick={() => handleSearchChange('titleSearch', '')}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              )
            }
          />
        </Search>
      </Stack>

      <Box display="flex" sx={{ my: 2 }}>
        <FormControl sx={{ mx: 2, width: 120 }}>
          <InputLabel>eSIM</InputLabel>
          <Select value={esimFilter} onChange={(e) => onFilterChange('esimFilter', e.target.value)} label="eSIM">
            <MenuItem value={1}>Yes</MenuItem>
            <MenuItem value={2}>No</MenuItem>
          </Select>
        </FormControl>

        <FormControl sx={{ mx: 2, width: 120 }}>
          <InputLabel>Data SIM</InputLabel>
          <Select
            value={dataSimFilter}
            onChange={(e) => onFilterChange('dataSimFilter', e.target.value)}
            label="Data SIM"
          >
            <MenuItem value={1}>Yes</MenuItem>
            <MenuItem value={0}>No</MenuItem>
          </Select>
        </FormControl>

        <FormControlLabel
          sx={{ mx: 2 }}
          control={
            <Checkbox
              checked={asanImzaFilter}
              onChange={(e) => onFilterChange('asanImzaFilter', e.target.checked)}
            />
          }
          label="Asan İmza"
        />

        <FormControl sx={{ mx: 2, width: 130 }}>
          <InputLabel>Rows per page:</InputLabel>
          <Select value={rowsPerPage} onChange={(e) => onRowsPerPageChange(parseInt(e.target.value, 10))}>
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </Select>
        </FormControl>

        <Button onClick={() => onNewOffer()} variant="contained">
          New Offer
        </Button>
      </Box>
    </Stack>
  );
};

export default SupplementaryOfferFilters;
